// extracted by mini-css-extract-plugin
module.exports = {"decor":"styles_decor__rL0OK","icon":"styles_icon__ZFyAd"};